module.exports = __webpack_public_path__ + "viz_hub_default.30002acb9657da133fd1fd2bae4058e2.png";